import { PRICE_SELECTED } from 'shared/data/quoteSteps';

export const buildFabricationData = (arg) => {
  const {
    parameters,
    quoteStep,
    fabricationVariant,
    project_number,
    project_reference,
  } = arg;

  if (quoteStep !== PRICE_SELECTED) return null;

  const form = new FormData();
  form.append('parameters[project_number]', project_number);
  form.append('parameters[project_reference]', project_reference);
  form.append('variant_id', fabricationVariant);

  Object.entries(parameters).forEach(([name, value]) => {
    if (name === 'quantities') {
      parameters[name].forEach((qty) => {
        form.append(`parameters[${name}][]`, qty);
      });
    } else if (value !== undefined && value !== null) {
      form.append(`parameters[${name}]`, value);
    }
  });

  const file = document.getElementById('gerber-file').files[0];

  // If the file is present, it means the user wants to add a new file or replace it for this line item,
  // else we should not send the filename parameter or it will be unlinked in the backend
  if (file) {
    form.append('parameters[filename]', file);
  } else {
    form.delete('parameters[filename]');
  }

  return form;
};

export const buildFabricationForm = (args) => {
  if (!args) return [];

  const fabricationForm = buildFabricationData(args);

  return fabricationForm ? [fabricationForm] : [];
};
